import Aircraft from './aircraft';
import AirlineCompany from './airlineCompany';
import Airport from './airport';
import Currency from '../currency';
import Entity from '../entity';
import FlightProvider from './flightProvider';
export default class FlightInput extends Entity<string> {
  flightNo: string;
  code: string;
  departureDate: string;
  arrivalDate: string;
  departureHour: string;
  arrivalHour: string;
  duration: string;
  totalQuota: string;
  isActive: boolean;
  baggageLimit: string;
  handBaggageLimit: string;
  currency: Currency;
  airlineCompany: AirlineCompany;
  airplane: Aircraft;
  fromAirport: Airport;
  toAirport: Airport;
  packageProvider: FlightProvider;
  flightEndDate: string;
}
